import {
    Avatar,
    CardHeader,
    Card,
    Box,
    Text,
    CardBody
} from 'grommet';
import { useEffect, useState } from 'react';
import RosterTable from './RosterTable';

import { getBoxscore, formatRecord } from './espnReader';
import { CURRENT_SEASON } from './config';

export default function LeagueCard(props) {
    const [teamInfo, setTeamInfo] = useState(null);
    const [matchupStats, setMatchupStats] = useState(null);
    const [status, setStatus] = useState('loading'); // 'loading' | 'ready' | 'error'

    useEffect(() => {
        let cancelled = false;
        const fetchBoxscore = async () => {
            setStatus('loading');
            try {
                const data = await getBoxscore(props.leagueID, CURRENT_SEASON, props.teamID);
                if (cancelled) return;
                if (!data || data.error || !data.boxscore || !data.team) {
                    setStatus('error');
                    return;
                }
                setTeamInfo(data.team);
                setMatchupStats(data.boxscore);
                setStatus('ready');
            } catch (error) {
                if (!cancelled) setStatus('error');
            }
        };
        fetchBoxscore();
        return () => { cancelled = true; };
    }, [props.leagueID, props.teamID]);

    if (status === 'loading') {
        return (
            <Card><CardBody pad="medium"><Text>Loading matchup…</Text></CardBody></Card>
        );
    }

    if (status === 'error') {
        return (
            <Card>
                <CardBody pad="medium">
                    <Text color="status-critical">
                        Couldn't load this matchup. The league may be private or unavailable.
                    </Text>
                </CardBody>
            </Card>
        );
    }

    // Highlight whichever side is this pal's own team.
    const ownTeamBackground = teamId => (teamInfo.id === teamId ? 'dark-3' : null);

    return (
        <Card>
            <CardHeader pad="medium">
                <Box direction="row" pad="small">
                    <Avatar size="small" src={teamInfo.logo || null} />
                    <Text>{teamInfo.name}</Text>
                </Box>
                <Box direction="row" pad="small">
                    <Text>{formatRecord(teamInfo.record?.overall)}</Text>
                </Box>
            </CardHeader>
            <CardBody pad="medium">
                <Box direction="row">
                    <Box background={ownTeamBackground(matchupStats.home.teamId)}>
                        <RosterTable team={matchupStats.home} />
                    </Box>
                    <Box background={ownTeamBackground(matchupStats.away.teamId)}>
                        <RosterTable team={matchupStats.away} />
                    </Box>
                </Box>
            </CardBody>
        </Card>
    );
}
